export default __webpack_public_path__ + "static/preview-db5a707f767cd04d05db6badda923f16.png";